import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-terms',
  standalone: true,
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
  pdfUrl!: SafeResourceUrl;
  pdfDirectUrl = 'assets/docs/Términos y Condiciones iké Now 2025, 06.pdf';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    // Redirección directa al PDF
    window.open(this.pdfDirectUrl, '_blank');
    window.history.back();
  }
}